module.exports = __webpack_public_path__ + "static/media/mastercard_original.3c036285.svg";